<template>
  <b-modal
    v-model="show"
    title="Clonar operação"
    @ok="handleClone"
    @hidden="handleClose"
    ok-title="Clonar"
    cancel-title="Cancelar"
  >
    <b-form-group
      label="Nome da nova operação:"
      label-for="clone-event-name"
    >
      <b-form-input
        id="clone-event-name"
        v-model="cloneName"
        type="text"
        required
      ></b-form-input>
    </b-form-group>
  </b-modal>
</template>

<script>
export default {
  name: 'CloneEventModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    eventName: {
      type: String,
      default: ''
    },
    eventId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      cloneName: ''
    }
  },
  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close')
        }
      }
    }
  },
  watch: {
    visible (newVal) {
      if (newVal) {
        this.cloneName = `${this.eventName} (cópia)`
      }
    }
  },
  methods: {
    handleClone () {
      this.$emit('clone', {
        id: this.eventId,
        name: this.cloneName
      })
      this.handleClose()
    },
    handleClose () {
      this.$emit('close')
    }
  }
}
</script>
